<template>
    <div id="contenedor-main-proyectos-validaciones">
        <listado-responsables
            :idProyecto="idProyecto">
        </listado-responsables>
    </div>
</template>

<script>
import ListadoResponsables from '@/components/administracion/control-proyectos/responsables/listado/Listado.vue';

export default {
  name: 'MainControlProyectosValidaciones',
  components: {
    ListadoResponsables,
  },
  data() {
    return {
      idProyecto: this.$route.params.idProyecto,
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
